import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useAgentCRM = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "",
    phone: "",
    email: "",
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);

  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/agentcrm/list", filter);
      setItems(response.data.agentcrms);
      setTotal(response.data.total);
      return response.data.agentcrms;
    } catch (error) {
      console.error(error);
    }
  };

  const toFormData = (agentCRM) => {
    const formData = new FormData();
    formData.append("id", agentCRM.id || 0);
    formData.append("name", agentCRM.name || "");
    formData.append("phone", agentCRM.phone || "");
    formData.append("email", agentCRM.email || "");

    if (agentCRM.file_upload) {
      formData.append("file", agentCRM.file_upload);
    } else {
      formData.append("file", agentCRM.file || "");
    }

    return formData;
  };

  const add = async (newData) => {
    try {
      const response = await automobyApi.post("/agentcrm/create", toFormData(newData), {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const update = async (newData) => {
    try {
      const response = await automobyApi.post("/agentcrm/update", toFormData(newData), {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await automobyApi.post("/agentcrm/delete", { id });
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    agentCRMService: {
      items,
      total,
      filter,
      setFilter,
      fetchList,
      add,
      update,
      remove,
    }
  };
};
